export const getActionOptions = (type) => {
  switch (type) {
    case "Script":
      return [
        { label: "Javascript", value: "Javascript" },
        { label: "CommandLine", value: "CommandLine" },
      ];
    case "Assertion":
    case "Validation":
      return [
        { label: "Assert Text", value: "validatePartial" },
        { value: "DynamicText", label: "Dynamic Text" },
        { value: "doNothing", label: "Do Nothing" },
        { value: "expression", label: "Expression" },
        { label: "Properties", value: "Properties" },
        { label: "Javascript", value: "Javascript" },
      ];
    case "Keyboard":
      return [
        { label: "arrowup", value: "arrowup" },
        { label: "arrowdown", value: "arrowdown" },
        { label: "enter", value: "enter" },
        { label: "escape", value: "escape" },
      ];
    case "Browser":
      return [
        { label: "refresh", value: "refresh" },
        { label: "back", value: "back" },
      ];
    case "Button":
      return [
        { label: "Click", value: "Click" },
        { label: "Double Click", value: "DblClick" },
      ];
    case "Alert":
      return [
        { label: "Alert OK", value: "AlertOK" },
        { label: "Alert Cancel", value: "AlertCancel" },
        { label: "Alert Text", value: "AlertText" },
        { label: "Alert Send", value: "AlertSend" },
        { label: "Assert Alert Text", value: "AssertAlertText" },
      ];
    case "Check Box":
      return [
        { label: "Click", value: "click" },
        { label: "Check", value: "check" },
        { label: "Uncheck", value: "uncheck" },
      ];
    case "Clipboard":
    case "Url":
    case "URL":
      return [{ label: "Get", value: "Get" }];
    case "DropDown":
      return [{ label: "Select", value: "Select" }];
    case "Link":
    case "SVGElement":
    case "Radio Button":
      return [
        { label: "Click", value: "Click" },
        { label: "Double Click", value: "dblClick" },
      ];
    case "File Upload":
      return [{ value: "Upload", label: "Upload" }];
    case "Inline":
      return [
        { label: "Inline", value: "Inline" },
        { label: "Test", value: "Test" },
      ];
    case "File":
      return [{ label: "Download", value: "Download" }];
    case "TextArea":
      return [
        { label: "Enter", value: "Enter" },
        { label: "Click", value: "Click" },
      ];
    case "TestCase":
      return [{ label: "Include", value: "Include" }];
    case "Send":
      return [{ label: "Email", value: "Email" }];
    case "Window":
      return [{ label: "New Tab", value: "NewTab" }];
    case "EditBox":
      return [
        { label: "Enter", value: "Enter" },
        { label: "Click", value: "Click" },
        { label: "Clear", value: "Clear" },
        { label: "Clear & Enter", value: "clear & enter" },
      ];
    case "mobile":
      return [
        { label: "Click", value: "click" },
        { label: "Swipe", value: "Swipe" },
        { label: "Find And Assign", value: "findAndAssign" },
        { label: "Tap", value: "tap" },
        { label: "Send Keys", value: "sendKeys" },
        { label: "Tap & Hold", value: "tapandhold" },
        { label: " Swipe And Select", value: "swipeandselect" },
        { label: " Navigation", value: "pressKeyCode" },
      ];
    case "Mouse":
      return [
        { label: "Click", value: "click" },
        { label: "Hover", value: "hover" },
        { label: "BlindClick", value: "BlindClick" },
        { label: "ScrollToRight", value: "ScrollToRight" },
        { label: "ScrollToLeft", value: "ScrollToLeft" },
      ];
    case "Api":
      return [{ label: "Test", value: "Test" }];
    case "conditionalLogic":
      return [
        { label: "For-Start", value: "forStart" },
        { label: "For-End", value: "forEnd" },
        { label: "If-Start", value: "ifStart" },
        { label: "If-End", value: "ifEnd" },
        { label: "For Continue", value: "forContinue" },
        { label: "For Break", value: "forBreak" },
      ];
    case "onscreen":
      return [{ label: "read", value: "read" }];
    case "mobileSensors":
      return [
        { label: "Retrieve GPS Information", value: "getgpsinfo" },
        { label: "Check Battery Status", value: "getbatteryinfo" },
        { label: "View Network Details", value: "getnetworkinfo" },
        { label: "Force Close Application", value: "closeapp" },
        { label: "Minimize Application", value: "minimizeapp" },
        { label: "Uninstall Application", value: "deleteapp" },
      ];
    case "mobilePermission":
      return [
        { label: "Notification", value: "notification" },
        { label: "Location Access Permission", value: "location" },
        { label: "Storage Access Permission", value: "storage" },
        { label: "Mobile Data Permission", value: "mobiledata" },
        { label: "Mobile Wifi Permission", value: "mobilewifi" },
        { label: "Mobile Bluetooth Permission", value: "mobilebluetooth" },
        { label: "Mobile Airplane Mode Permission", value: "airplanemode" },
        { label: "Mobile Hotspot Permission", value: "mobilehotspot" },
      ];
    case "visualAnalysis":
      return [
        { value: "visionAI", label: "Vision AI" },
        { value: "checkCarousel", label: "Check Carousel" },
        { value: "checkVideoPlaying", label: "Check Video Playing" },
      ];

    default:
      return [{ label: "Click", value: "Click" }];
  }
};